<div
    [ngSwitch]="Scope.websiteMode"
    [ngClass]="{
        'scss-website-background-color-only': kind === WebsiteBlockReviewsType.Default,
        'scss-block-background-color-variable': kind === WebsiteBlockReviewsType.AccentBackgroundDefault
    }">
    <ng-container *ngSwitchCase="WebsiteMode.Live">
        <div
            class="d-flex position-relative design-block"
            [ngClass]="{ 'justify-content-center': !isMobile }">
            <ng-container *ngTemplateOutlet="blockContent"></ng-container>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="WebsiteMode.ReadOnly">
        <div
            class="d-flex position-relative"
            [ngClass]="{ 'justify-content-center': !isMobile }">
            <!-- The SVG for the sidebar comes from the TP -->
            @if (designBlockMode !== DesignBlockMode.Sidebar) {
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            }
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="WebsiteMode.Preview">
        <lib-design-blocks-action-menu>
            <ng-container *ngTemplateOutlet="blockContent"></ng-container>
        </lib-design-blocks-action-menu>
    </ng-container>
</div>

<ng-template #blockContent>
    @if (Scope.websiteMode !== WebsiteMode.ReadOnly || (Scope.websiteMode === WebsiteMode.ReadOnly && designBlockMode !== DesignBlockMode.Sidebar)) {
        @if (!loading) {
            <div class="padding-48 w-100">
                @if (allReviewsLength === 0) {
                    <div class="sb-empty-state-background-card">
                        <lib-empty-state
                            [emptyStateGraphic]="EmptyStateGraphic.Reviews">
                            <ng-container
                                emptyStateText
                                i18n="@@Common_ReviewsBlock_EmptyState_Title">
                                No public reviews yet
                            </ng-container>
                            <ng-container
                                emptyStateDescription
                                i18n="@@Common_ReviewsBlock_EmptyState_Description">
                                Reviews will appear in this section once they've been received and made public
                            </ng-container>
                        </lib-empty-state>
                    </div>
                } @else if (allReviewsLength != null && allReviewsLength > 0 && visibleReviews.length == 0) {
                    <div class="sb-empty-state-background-card">
                        <lib-empty-state
                            [emptyStateGraphic]="EmptyStateGraphic.Reviews">
                            <ng-container
                                emptyStateText
                                i18n="@@Common_ReviewsBlockEmptyStateFiltered_Text">
                                No reviews to display
                            </ng-container>
                            <ng-container
                                emptyStateDescription
                                i18n="@@Common_ReviewsBlockEmptyStateFiltered_Description">
                                There aren't any reviews to display for the selected #teacher#.
                            </ng-container>
                        </lib-empty-state>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="reviews"></ng-container>
                }
            </div>
        } @else if (Scope.websiteMode === WebsiteMode.Preview) {
            <div class="py-3">
                <span class="spinner-border spinner-border-lg"></span>
            </div>
        }
    }
</ng-template>

<ng-template #reviews>
    <div
        class="reviews-container align-items-start w-100"
        [style.grid-template-columns]="gridColumns">
        @if (reviewSummary) {
            <lib-star-rating
                class="review-item"
                [kind]="StarRatingViewKind.Website"
                [numReviews]="reviewSummary.TotalRatings"
                [ratingValue]="reviewSummary.AverageRating"
                [websiteTextClass]="kind === WebsiteBlockReviewsType.Default ? 'reviews-block-text-default' : 'reviews-block-text-accent'"></lib-star-rating>
        }
        @for (review of visibleReviews; track review) {
            <lib-review-card
                class="review-item"
                [displayItem]="review"></lib-review-card>
        }
    </div>
    @if (allPublicReviewsLength != null && allPublicReviewsLength > maxColPerRow) {
        <div class="d-flex align-items-center justify-content-center w-100 p-3">
            <lib-button
                [ngClass]="{
                    'show-more-button-default': kind === WebsiteBlockReviewsType.Default,
                    'show-more-button-accent': kind === WebsiteBlockReviewsType.AccentBackgroundDefault
                }"
                [kind]="ButtonKind.Link"
                [suffixIcon]="!showMoreState ? Icon.Common.CaretDown : Icon.Common.CaretUp"
                (clicked)="ShowMoreClicked(!showMoreState)">
                <ng-container label>
                    @if (!showMoreState) {
                        <ng-container i18n="@@CommonShowMoreButton">Show More</ng-container>
                    } @else {
                        <ng-container i18n="@@CommonShowLessButton">Show Less</ng-container>
                    }
                </ng-container>
            </lib-button>
        </div>
    }
</ng-template>
